import styled, { css } from "styled-components";

interface PropsBackgroundMobile {
  isActive: boolean;
}

interface PropsItemMenu {
  currentItemActive: boolean;
}

export const Container = styled.div<PropsBackgroundMobile>`
  ${({ theme, isActive }) => css`
    display: inline-block;
    opacity: ${isActive ? 1 : 0};
    pointer-events: ${isActive ? "all" : "none"};
    width: 100%;
    height: 100%;
    min-height: 100vh;
    background-image: ${`linear-gradient(2deg, ${theme.colors.transactionSecondary} 1%, ${theme.colors.transactionPrimary} 83%)`};
    position: fixed;
    transition: opacity 0.2s ease-in;
    z-index: 3;

    @media (min-width: 768px) {
      width: 380px;
      background-image: ${`linear-gradient(2deg, ${theme.colors.transactionSecondary} 1%, ${theme.colors.transactionPrimary} 83%)`};
      position: static;
      opacity: 1;
      pointer-events: all;
    }
  `}
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80px;
  background-color: ${({ theme }) => theme.colors.white};
  position: relative;
  padding: 0.75rem 0;

  svg:nth-child(2) {
    width: 180px;
  }

  svg:nth-child(3) {
    width: 120px;
  }

  @media (min-width: 768px) {
    svg:nth-child(2) {
      width: 150px;
    }

    svg:nth-child(3) {
      width: 90px;
    }
  }

  @media (min-width: 1280px) {
    svg:nth-child(2) {
      width: 190px;
    }

    svg:nth-child(3) {
      width: 130px;
    }
  }
`;

export const MenuHamburguer = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    background-image: ${`linear-gradient(269deg, ${theme.colors.transactionSecondary} 119%, ${theme.colors.transactionPrimary} 24%)`};
    padding: 0 1rem;
    > svg {
      width: 100px;
    }

    button {
      background-color: transparent;
      border: none;

      svg {
        width: 35px;
        height: 35px;
        color: ${theme.colors.darkWhite};
      }
    }

    @media (min-width: 768px) {
      display: none;
    }
  `}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1.5rem;
  position: relative;
  height: calc(100% - 105px);
`;

export const ItemMenu = styled.a<PropsItemMenu>`
  ${({ theme, currentItemActive }) => css`
    display: flex;
    align-items: center;
    color: ${theme.colors.darkWhite};
    margin: 0.25rem 1.5rem 0.25rem 0.75rem;
    padding: 0.25rem 0.5rem;
    background-color: ${currentItemActive ? theme.colors.orange : "initial"};
    border: none;
    transition: background-color 0.2s ease-in;
    border-radius: 2rem;

    &:hover {
      background-color: ${theme.colors.orange};
    }

    & + button {
      margin-top: 0.75rem;
    }

    span {
      padding-left: 0.75rem;
      font-weight: bold;
      font-size: 0.875rem;
      color: ${theme.colors.darkWhite};
    }

    svg {
      width: 25px;
      height: 25px;
      fill: ${theme.colors.darkWhite};
      margin-left: 1rem;
    }
  `}
`;

export const CloseHeader = styled.button`
  ${({ theme }) => css`
    background-color: transparent;
    border: none;
    position: absolute;
    left: 10px;
    top: 10px;

    svg {
      fill: ${theme.colors.primary};
    }

    @media (min-width: 768px) {
      display: none;
    }
  `}
`;

export const Logout = styled.button`
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 20px;
  left: 0;
  padding-left: 1rem;
  background-color: transparent;
  border: none;

  svg {
    width: 25px;
    height: 25px;
    fill: ${({ theme }) => theme.colors.darkWhite};
  }

  span {
    padding-left: 1rem;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.darkWhite};
  }
`;
